import React, { useEffect, useState } from 'react';
import uuid from 'uuid-random';
import { RouteComponentProps } from '@reach/router';
import { FlexBehavior, FlexJustify, Spinner } from 'react-magma-dom';
import { RelatedWrapperComponent } from '../../components/RelatedElement/RelatedWrapperComponent';
import { ShortRelatedItem } from '../../components/RelatedElement/ShortRelatedItem';
import { Breadcrumb } from '../../components/Breadcrumb/Breadcrumb';
import { ContactUsError } from '../../components/ContactUsError';
import { MarginWrapper, StyledColoredLine } from '../../components/Styled';
import { StyledHeading } from '../../components/Styled/StyledRelatedNav';
import { assesmentsApi } from '../../API/assesments';
import { getStageColors } from '../../utils';
import { FIRST_ELEMENT_MARGIN } from '../../utils/assessment';
import { NOT_FOUND, SHORT_RELATED_ITEM_WIDTH } from '../../constants';
import { IAsset } from '../../constants/assets';
import { StyledCenteredSpinnerWrapper } from '../../components/Styled/StyledWrappers';

interface IAssessmentList extends RouteComponentProps {
  stage: string;
  categoryName: string;
  textType: string;
}

export const AssessmentList = (props: IAssessmentList): JSX.Element => {
  const { stage, categoryName, textType, navigate } = props;

  const [list, setList] = useState<IAsset[] | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const { main: mainColor, gradient: gradientColor } = getStageColors(stage);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      try {
        const {
          data: { data },
        } = await assesmentsApi.getAssessment(stage);
        const list = data?.subcategories
          ?.find(subcategory => subcategory.name == categoryName)
          ?.subcategories?.find(subcategory => subcategory.name == textType)?.assets;

        // If a list is undefined, wrong textType or categoryName is provided
        if (!list) {
          navigate && navigate(`/${NOT_FOUND}`);
        }

        setList(list);
      } catch (error) {
        setError(!!error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [stage]);

  if (error) {
    return <ContactUsError />;
  }

  if (isLoading) {
    return (
      <StyledCenteredSpinnerWrapper behavior={FlexBehavior.container} justify={FlexJustify.center}>
        <Spinner color={mainColor} size={50} />
      </StyledCenteredSpinnerWrapper>
    );
  }

  if (!list) {
    return <></>;
  }

  return (
    <>
      <StyledColoredLine color={gradientColor} />
      <MarginWrapper margin="38px 0px 0px 0px">
        <RelatedWrapperComponent width={SHORT_RELATED_ITEM_WIDTH}>
          <Breadcrumb items={[{ title: stage, to: `/assessment/${stage}` }]} lastItem={categoryName} />
          <StyledHeading margin={FIRST_ELEMENT_MARGIN} size={36}>
            {textType}
          </StyledHeading>
          {list.map(item => {
            return (
              <ShortRelatedItem
                title={item.title}
                type={item.type}
                fileLink={item.links.self}
                defaultColor={mainColor}
                gradient={gradientColor}
                key={uuid()}
              />
            );
          })}
        </RelatedWrapperComponent>
      </MarginWrapper>
    </>
  );
};
